import { Table, ConfigProvider } from "antd";

import CustomLink from "@/components/ui/CustomLink";

import routes from "@/routes";
import { formateISODateToMoment, removeEmoji } from "@/utils";

// Таблица связанных объектов
// Содержит список объектов, которые ссылаются на текущий с возможностью сортировки по полям
const RelatedObjectsTable = ({
  data,
  unit_uuid,
  theme = null,
  isAdmins = false,
}) => {
  const columns = [
    {
      title: "Название",
      dataIndex: "object_name",
      key: "object_name",
      sorter: {
        compare: (a, b) => a.object_name.localeCompare(b.object_name),
      },
      render: (_, { definition_uuid, object_uuid, object_name }) => {
        return (
          <CustomLink
            to={
              unit_uuid
                ? routes.unitObjectDetail(
                    unit_uuid,
                    definition_uuid,
                    object_uuid
                  )
                : isAdmins
                ? routes.administration.objectDetail(
                    definition_uuid,
                    object_uuid
                  )
                : routes.objectDetail(definition_uuid, object_uuid)
            }
          >
            {object_name}
          </CustomLink>
        );
      },
    },
    {
      title: "Тип",
      dataIndex: "definition_name",
      key: "definition_name",
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.definition_name.localeCompare(b.definition_name),
      },
      render: (definition_name) => {
        return <div>{removeEmoji(definition_name)}</div>;
      },
    },
    {
      title: "Дата создания",
      dataIndex: "created_at",
      key: "created_at",
      sorter: {
        compare: (a, b) => Date.parse(a.created_at) - Date.parse(b.created_at),
      },
      render: (created_at) => {
        return <div>{formateISODateToMoment(created_at)}</div>;
      },
    },
  ];

  const isPassport = theme === "passport";

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            borderColor: isPassport ? "#E9E9E9" : "#f7f7f7",
            // rowHoverBg: isPassport ? "#F8FBFF" : "#fcfcfc",
          },
        },
      }}
    >
      <Table
        dataSource={data}
        columns={columns}
        rowKey="object_uuid"
        pagination={false}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        size="small"
        scroll={{
          x: "100%",
        }}
        bordered={isPassport}
      />
    </ConfigProvider>
  );
};

export default RelatedObjectsTable;
